/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import { put, call, takeLatest } from "redux-saga/effects";
import {
  RESEND_EMAIL,
  RESEND_EMAIL_SUCCESS,
  RESEND_EMAIL_FAILURE,
} from "../actions/actionTypes";
import { Auth } from "../api/agent";

function* resendEmail(action) {
  try {
    const payload = yield call(Auth.resendActivationEmail, action.payload);
    yield put({ type: RESEND_EMAIL_SUCCESS, payload });
  } catch (error) {
    const errResp = error.response.body;
    yield put({ type: RESEND_EMAIL_FAILURE, errResp });
  }
}

export function* watchResendEmail() {
  yield takeLatest(RESEND_EMAIL, resendEmail);
}
